import React from 'react';

const ImportMoneyPage = () => {
  return <div>ImportMoneyPage</div>;
};

export default ImportMoneyPage;
